class TSMainProduct extends HTMLElement {
  constructor() {
    super();
    this.isLoading = false;
  }

  connectedCallback() {
    this.productVariants = JSON.parse(this.querySelector("[data-dynamic-variants]").textContent);
    this.cart = document.querySelector("ts-cart-drawer");
    this.gallery = this.querySelector('[id^="ProductGallery-"] ts-slider-component');
    this.navGallery = this.querySelector('[id^="ProductGalleryNav-"]');

    this.querySelector('[id^="ProductOptions-"]')?.addEventListener("change", this.onVariantChange.bind(this));
    this.querySelector('[id^="ProductForm-"]')?.addEventListener("submit", this.onFormSubmit.bind(this));
    this.initClickListeners();
  }

  onVariantChange(event) {
    const searchParams = new URLSearchParams();

    this.querySelector("input[name='id']").value = event.target.value;
    searchParams.set('variant', event.target.value);

    const newProductUrl = window.location.origin + window.location.pathname + `?${searchParams.toString()}`;
    window.history.replaceState({}, '', newProductUrl);

    this.querySelector('[id^="ProductSubmit-"]').toggleAttribute("disabled", event.target.dataset.available !== "true");
  }

  onFormSubmit(event = false) {
    if (event) event.preventDefault();

    if (this.isLoading) return;

    const sections = [];
    if (this.cart) sections.push("ts-cart-drawer");

    const cartData = {
      items: [
        {
          id: parseInt(this.querySelector("[name='id']").value),
          quantity: parseInt(this.querySelector("[name='quantity']").value)
        }
      ],
      sections: sections,
      sections_url: window.location.pathname
    };

    this.addToCart(cartData);
  }

  addToCart(data) {
    if (!data) return;

    this.toggleLoading();

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
    .then(response => response.json())
    .then(response => {
      if (!response.items) {
        const error = new Error(response.description);
        throw error;
      } else {
        this.toggleLoading();
        
        if (this.cart) {
          this.cart.renderContent(response.sections);
          this.cart.open();
        } else {
          window.location.pathname = "/cart";
        }
      }
    })
    .catch(error => this.showError(error))
    .finally(() => this.toggleLoading(true));
  }

  initClickListeners() {
    this.addEventListener("click", (e) => {
      if (e.target.hasAttribute("data-action")) {
        switch (e.target.dataset.action) {
          case "change-slide":
            this.gallery.scrollToSlide(parseInt(e.target.dataset.slide));
            break;
          case "fact-open":
            const fact = this.querySelector(`[data-fact-popup="${e.target.dataset.fact}"]`);
            fact?.classList.add("open");
          case "fact-close":
            e.target.closest("[data-fact-popup]").classList.remove("open");
            break;
        }
      }
    })

    this.addEventListener("slider-updated", (e) => {
      this.navGallery.querySelectorAll("li").forEach(slide => {
        slide.classList.toggle("active", slide.dataset.slide == e.detail.currentSlide)
      })
    })
  }

  showError(error) {
    console.error(error);

    if (!this.querySelector("[product-notification]")) return;

    const messageBlock = this.querySelector("[product-notification]");

    messageBlock.innerText = error.message;
    setTimeout(() => {messageBlock.innerText = ''}, 5000);
    messageBlock.scrollIntoView({behavior: "smooth",block:"center"});
  }

  toggleLoading(turnOff = false) {
    this.isLoading = !this.isLoading;
    if (turnOff) this.isLoading = false;
    this.classList.toggle("loading", this.isLoading);
  }
}

if (document.querySelector("ts-main-product")) {
  customElements.define("ts-main-product", TSMainProduct);
}

class TSSliderComponent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.currentSlide = 1;
    this.allowEvents = this.getAttribute("data-allow-events") === "true";
    this.hideControls = this.getAttribute("data-hide-controls") !== "false"

    this.slider = this.querySelector('[id^="Slider-"]');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    this.scrollbar = this.querySelector("[slider-scrollbar]");
    this.scrollbarThumb = this.querySelector("[slider-scrollbar] span");

    this.pagination = this.querySelector('[slider-pagination]');

    if (!this.slider) return;

    this.update();
    window.addEventListener('resize', this.update.bind(this));
    this.slider.addEventListener('scroll', this.update.bind(this));

    if (this.prevButton && this.nextButton) {
      this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    }

    if (this.pagination) {
      this.pagination.addEventListener("click", this.onDotClick.bind(this))
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    if (event.currentTarget.name === 'previous' && this.currentSlide > 1) {
      this.currentSlide -= 1;
    } else if (event.currentTarget.name === 'next' && this.currentSlide < this.maxLength) {
      this.currentSlide += 1;
    }
    this.scrollToSlide(this.currentSlide);
  }

  onDotClick(event) {
    event.preventDefault();
    if (!event.target.hasAttribute("data-slide")) return;

    const slideIndex = parseInt(event.target.dataset.slide);
    this.scrollToSlide(slideIndex);
  }

  scrollToSlide(index) {
    this.slider.scrollTo({
      left: this.querySelector(`[id^="Slide-"]:nth-child(${index})`).offsetLeft,
      behavior: 'smooth'
    });
  }

  update() {
    const items = this.querySelectorAll('[id^="Slide-"]');
    const scrollLeft = this.slider.scrollLeft;
    const scrollWidth = this.slider.scrollWidth;
    const clientWidth = this.slider.clientWidth;
    const blockWidth = items[0]?.offsetWidth ?? 0;
    const gap = window.innerWidth < 750 ? 16 : 24;
    const hasScroll = this.slider.scrollWidth > clientWidth;
      
    this.maxLength = items.length - (Math.floor(clientWidth / blockWidth) - 1);
    this.currentSlide = Math.round(scrollLeft / (blockWidth + gap)) + 1;
    
    if (this.prevButton && this.nextButton) {
      this.prevButton.toggleAttribute("disabled", this.currentSlide == 1);
      this.nextButton.toggleAttribute("disabled", this.currentSlide == this.maxLength);
  
      if (this.hideControls) {
        this.prevButton.classList.toggle("hidden", !hasScroll);
        this.nextButton.classList.toggle("hidden", !hasScroll);
      }
    }

    if (this.scrollbarThumb) {      
      const thumbWidth = (clientWidth / scrollWidth) * 100;
      const thumbPosition = (scrollLeft / (scrollWidth - clientWidth)) * 100;

      this.scrollbarThumb.style.left = `${thumbPosition}%`;
      this.scrollbarThumb.style.width = `${thumbWidth}%`;
      this.scrollbarThumb.style.transform = `translateX(-${thumbPosition}%)`;
      this.scrollbar.classList.toggle("hidden", !hasScroll);
    }

    if (this.pagination) {
      this.updatePagination();
    }
  
    if (this.allowEvents) {
      this.dispatchEvent(
        new CustomEvent("slider-updated", {
          detail: {
            currentSlide: this.currentSlide
          },
          bubbles: true,
        })
      );
    }
  }

  updatePagination() {
    const slides = this.querySelectorAll('[id^="Slide-"]');

    if (!this.slider || slides.length === 0 || !this.pagination) return;

    const containerWidth = this.slider.clientWidth;
    const slideWidth = slides[0].offsetWidth;

    const slidesPerPage = Math.floor(containerWidth / slideWidth);
    const totalPages = slides.length - (slidesPerPage - 1);

    this.pagination.innerHTML = '';
    this.pagination.classList.toggle("hidden", totalPages === 1);

    for (let i = 1; i <= totalPages; i++) {
      const dot = document.createElement('span');
      dot.setAttribute("data-slide", i);
      if (i === this.currentSlide) dot.classList.add("active");
      this.pagination.appendChild(dot);
    }
  }
}

customElements.define("ts-slider-component", TSSliderComponent);